import BenchlingConfig from 'BenchlingConfig';
import {
  ProcedureRunDataEntryMode,
  ProcedureType,
  StudyType,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CLINICAL_STUDIES_VALIDATION_CONSTANTS} from 'studies/StudyConstants';

import {TypedStudyAdapter} from '../utils/TypedStudyTypes';
import ClinicalStudyDesignTabContents from './ClinicalStudyDesignTabContents';
import ClinicalStudyExecutionOverview from './ClinicalStudyExecutionOverview';
import ClinicalStudyOverviewTabContents from './ClinicalStudyOverviewTabContents';

export const ClinicalStudyAdapter: TypedStudyAdapter = {
  type: StudyType.CLINICAL,

  isFlagEnabled: () => BenchlingConfig.STUDIES_ENABLE_CLINICAL,

  createCapabilityFeature: null,

  procedureType: ProcedureType.ASSAY,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: false,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: false,

  isVisualizationEnabled: false,

  isOOTBChartingEnabled: false,

  maxRunsPerStudy: () => CLINICAL_STUDIES_VALIDATION_CONSTANTS.MAX_NUM_ASSAY_RUNS_PER_CLINICAL_BASED_STUDY,

  defaultProcedureRunDataEntryMode: ProcedureRunDataEntryMode.INDIVIDUAL_CONDITION_REPLICATES,

  allowReturnToDesignPhase: true,

  allowRequireDesignApproval: BenchlingConfig.STUDIES_ENABLE_REVIEW,

  creation: {},
  design: {
    ui: {
      tab: ClinicalStudyDesignTabContents,
    },
  },
  overview: {
    ui: {
      tab: ClinicalStudyOverviewTabContents,
      execution: ClinicalStudyExecutionOverview,
      design: null,
    },
  },
  review: {
    analysis: {
      disallowAdhocAnalysis: true,
    },
  },
};
